import { useApolloClient } from '@apollo/client';
import { useLogoutRider, useLogoutDriver } from './useAuthMutations';
import { useAuthStore, useUserStore } from '../../stores';

export const useLogout = () => {
  // Global state.
  const { resetAuthState } = useAuthStore();
  const { userType, resetUserState } = useUserStore();

  // Access apollo client (for clearing cache).
  const apolloClient = useApolloClient();

  // Logout mutations.
  const { logoutRider } = useLogoutRider();
  const { logoutDriver } = useLogoutDriver();

  // Logout event.
  const logout = async () => {
    try {
      // Call the appropriate logout mutation.
      if (userType === 'rider') {
        await logoutRider();
      } else if (userType === 'driver') {
        await logoutDriver();
      } else {
        // If userType is null/undefined, we can't logout from backend
        // but we should still clear frontend state
        console.warn("No userType found - skipping backend logout");
      }

      // Clear the Apollo Client cache.
      await apolloClient.clearStore();

      // Reset global state.
      resetAuthState();
      resetUserState();

      // Navigate to home page.
      window.location.href = '/';
    } catch (error) {

      // Even if logout fails, still clear local state and redirect.
      await apolloClient.clearStore();
      resetAuthState();
      resetUserState();

      // Navigate to home page.
      window.location.href = '/';
    }
  };

  return logout;
};
